// extracted by mini-css-extract-plugin
module.exports = {"content":"DeviationType_content__3OM-c","submitBtn":"DeviationType_submitBtn__5rBOC"};